<template>

  <!-- XOL-67 (B6): the content fields of the request create form (ActionDetails.vue), extracted: Actual Date (Tower Co),
       Target Date, Priority, Summary (Tower Co) and Remarks (Tower Co). ActionDetails renders it where those fields were; Step 5
       of an RTA renders it for the RTS it opens. It writes into `value` (the form object) in place, as the template always did,
       and says `input` after any change. It must sit inside an el-form (the controls are form items). -->
  <div class="request-create-fields">

    <el-row style="padding-top: 1em;">
      <el-col v-if="isTowerCo()" :sm="24" :md="12" :lg="8">
        <date-input label="Actual Date" v-model="value.actualDate" :error="errors.actualDate || null" :disabled="disabled" />
      </el-col>

      <el-col :sm="24" :md="12" :lg="isTelco() ? 12 : 8">
        <date-input label="Target Date" v-model="value.targetDate" :error="errors.targetDate || null" :disabled="disabled" />
      </el-col>

      <el-col :sm="24" :md="12" :lg="isTelco() ? 12 : 8">
        <select-priority v-model="value.priority" :error="errors.priority || null" :disabled="disabled" @change="onPriority" />
      </el-col>

    </el-row>

    <text-input v-if="isTowerCo()" label="Summary" prop="summary" v-model="value.summary" :error="errors.summary || null" :disabled="disabled" placeholder="Summary of action" :maxlength="summaryMax" style="padding-top: 0.5em;" />

    <!-- Read only (Step 5 seen by a Tower Co user who may not fill it in): the remarks as a framed read-only block, not a greyed textarea. -->
    <read-only-remarks v-if="isTowerCo() && readOnly" label="Remarks" :html="remarksHtml" />

    <el-form-item v-else-if="isTowerCo()" prop="remarks" label="Remarks">
      <el-input type="textarea" :rows="3" v-model="value.remarks" :disabled="disabled" />
    </el-form-item>

  </div>

</template>

<script>

import SelectPriority from '@/components/atoms/selects/SelectPriority'
import ReadOnlyRemarks from '@/components/atoms/ReadOnlyRemarks'

export default {
  name: 'RequestCreateFields',

  components: { SelectPriority, ReadOnlyRemarks },

  props: {

    // The form object: { actualDate, targetDate, priority, summary, remarks }. Edited in place.
    value: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    // Step 5, read only: the Remarks are a ReadOnlyRemarks block. Off, ActionDetails is unchanged.
    readOnly: {
      type: Boolean,
      default: false
    },

    // XOL-67 (B10): the most characters the Summary takes (Step 5's RTS: 150, API DEV-48); the field stops there and shows a counter.
    // Null (the create form of ActionDetails): no limit, as before.
    summaryMax: {
      type: Number,
      default: null
    },

    // Inline errors by field ('targetDate': 'Enter the Target Date.'); Step 5 uses them.
    errors: {
      type: Object,
      default: function () { return {} }
    }

  },

  computed: {

    // The remarks are plain text from a textarea; ReadOnlyRemarks shows HTML (and sanitises it).
    remarksHtml () {
      var text = this.value.remarks

      if (text === null || text === undefined || String(text).trim() === '') {
        return ''
      }

      return '<p>' + String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r?\n/g, '<br>') + '</p>'
    }

  },

  methods: {

    // ActionDetails re-checks its Save gate when the priority changes.
    onPriority (priority) {
      this.$emit('priority-change', priority)
    }

  },

  watch: {

    value: {
      deep: true,
      handler () {
        this.$emit('input', this.value)
      }
    }

  }

}

</script>
